import {AppDispatch} from 'Store'
import {connect} from 'react-redux'
import {StartCognitiveTest} from './StartCognitiveTest'
import {RootState} from 'Store/Reducers'
import {
  getCognitiveTestResults,
  getAssessments,
  getConsents,
  changeCognitiveTestStatus,
} from 'Store/Actions'

const mapStateToProps = (state: RootState) => ({
  user: state.auth.data,
  downloadLink: state?.assessments?.cognitiveTestResults?.items[0]?.resultFile,
  assessments: state.assessments,
  consents: state?.consents?.data.consents,
})

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  getAssessments: () => dispatch(getAssessments()),
  getCognitiveTestResults: (value: string) =>
    dispatch(getCognitiveTestResults(value)),
  getConsents: () => dispatch(getConsents()),
  changeCognitiveTestStatus: (value: string) =>
    dispatch(changeCognitiveTestStatus(value)),
})

export const StartCognitiveTestContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(StartCognitiveTest)
